<template>
  <!--<e-card @toggleDrag="$emit('toggleDrag')" class="e-card col-md-12 col-lg-4 col-xl-2">-->
  <e-card @toggleDrag="$emit('toggleDrag')" :class="sizeClasses">
    <b-tab title="Pie Chart" active>
      <highcharts :options="options" ref="piChart" class="pie-chart-container"></highcharts>
      <div class="e-card__content pt-0 d-none d-xl-flex flex-column">
        <hr class="e-divider">
        <p class="text-center eh-secondary-text pb-3 pt-2">Last Achievements:</p>
        <ul class="ee-list eh-primary-text">
          <li><p class="mr-4">Sigma Forecasting:</p><p class="ml-auto">+ 75 CP</p></li>
          <li><p class="mr-4">Moderating Litecoin:</p><p class="ml-auto">+ 50 CP</p></li>
        </ul>
      </div>
      <div class="e-card__content d-sm-flex d-xl-none align-items-center justify-content-center">
        <b-btn ref="popoverInfoBtn1" class="e-btn e-btn--outlined e-btn--color--gray-dark e-btn--size--small">Learn More</b-btn>
        <b-popover class="e-popover" :target="() => this.$refs.popoverInfoBtn1" placement="top" triggers="hover focus">
          <p class="text-center eh-secondary-text pb-3">Last Achievements:</p>
          <ul class="ee-list eh-primary-text">
            <li><p class="mr-4">Sigma Forecasting:</p><p class="ml-auto">+ 75 CP</p></li>
            <li><p class="mr-4">Moderating Litecoin:</p><p class="ml-auto">+ 50 CP</p></li>
          </ul>
        </b-popover>
      </div>
    </b-tab>
    <b-tab title="Table" class="e-card__content">
      <div class="d-flex align-items-center">
        <p class="eh-secondary-text">Contribution Pts.</p>
        <span class="ml-auto eh-accent-text">2 380</span>
      </div>
      <hr class="e-divider">
      <div class="d-flex">
        <ul class="e-currency-table-list">
          <li class="e-currency-table-list__item">
            <div class="e-avatar size-10 bg-info"></div>
            <span class="e-currency-table-list__currency">BTC</span>
            <span class="e-currency-table-list__value eh-secondary-text">36%</span>
          </li>
          <li class="e-currency-table-list__item">
            <div class="e-avatar size-10 bg-warning"></div>
            <span class="e-currency-table-list__currency">ETH</span>
            <span class="e-currency-table-list__value eh-secondary-text">40%</span>
          </li>
          <li class="e-currency-table-list__item">
            <div class="e-avatar size-10 bg-success"></div>
            <span class="e-currency-table-list__currency">LTC</span>
            <span class="e-currency-table-list__value eh-secondary-text">4%</span>
          </li>
          <li class="e-currency-table-list__item">
            <div class="e-avatar size-10 bg-primary"></div>
            <span class="e-currency-table-list__currency">EMiX</span>
            <span class="e-currency-table-list__value eh-secondary-text">28%</span>
          </li>
          <li class="e-currency-table-list__item">
            <div class="e-avatar size-10 bg-danger"></div>
            <span class="e-currency-table-list__currency">Other</span>
            <span class="e-currency-table-list__value eh-secondary-text">2%</span>
          </li>
        </ul>
      </div>

      <hr class="e-divider">

      <div class="d-none d-xl-flex flex-column">
        <p class="text-center eh-secondary-text pb-3 pt-2">Last Achievements:</p>
        <ul class="ee-list eh-primary-text">
          <li><p class="mr-4">Sigma Forecasting:</p><p class="ml-auto">+ 75 CP</p></li>
          <li><p class="mr-4">Moderating Litecoin:</p><p class="ml-auto">+ 50 CP</p></li>
        </ul>
      </div>

      <div class="e-card__content d-sm-flex d-xl-none align-items-center justify-content-center pt-2 pb-0">
        <b-btn ref="popoverInfoBtn2" class="e-btn e-btn--outlined e-btn--color--gray-dark e-btn--size--small">Learn More</b-btn>
        <b-popover class="e-popover" :target="() => this.$refs.popoverInfoBtn2" placement="top" triggers="hover focus">
          <p class="text-center eh-secondary-text pb-3">Last Achievements:</p>
          <ul class="ee-list eh-primary-text">
            <li><p class="mr-4">Sigma Forecasting:</p><p class="ml-auto">+ 75 CP</p></li>
            <li><p class="mr-4">Moderating Litecoin:</p><p class="ml-auto">+ 50 CP</p></li>
          </ul>
        </b-popover>
      </div>
    </b-tab>
  </e-card>
</template>

<script>
  import ECard from '../../elements/card/card';
  import DynamicSizeMixin from '../../../mixins/dynamicSize';

	export default {
		name: "ec-chart",
    components: {ECard},
    mixins: [DynamicSizeMixin],
    computed: {
      options() {
        return {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            height: '100%',
            // width: '100%',
          },
          tooltip: {
            useHTML: true,
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
            shadow: true,
            formatter: function () {
              let render;

              render =
                '<div class="e-pie-chart__tooltip">' +
                '<div class="e-pie-chart__logo e-avatar size-30">' +
                '<img src="/static/assets/bitcoin.svg">' +
                '</div>' +
                '<div class="e-pie-chart__info">' +
                `<div class="e-pie-chart__asset">${this.key}</div>` +
                `<div class="e-pie-chart__value">${this.y}%</div>` +
                '</div>' +
                '</div>';

              return render;
            },
          },
          title: {
            text: '<span>2 340</span><br/>Contribution <br/>Pts.',
            useHTML: false,
            align: 'center',
            verticalAlign: 'middle',
            y: -15,
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              size: '100%',
              // colors: ['#00c2ff', '#ff5656', '#ffab48', '#6248ff', '#ff48ab', '#00e3ba'],
              colors: ['#0e3d60', '#0e4b6e', '#0e648c', '#116091', '#1472ad', '#1490cb'],
              dataLabels: {
                enabled: true,
                useHTML: true,
                format: '{point.y}%',
                distance: -30,
                inside: true,
                className: 'pie-chart-label',
              },
            },
          },
          credits: {
            enabled: false,
          },
          series: [{
            name: 'Share',
            innerSize: '48%',
            data: [
              { name: 'Bitcoin', y: 36 },
              { name: 'Litecoin', y: 27 },
              { name: 'Ethereum', y: 14 },
              { name: 'Bitcoin Cash', y: 9 },
              { name: 'Lisk', y: 4 },
              { name: 'Other', y: 10 }
            ]
          }]
        }
      },
      optionsLine() {
        return {
          chart: {
            type: 'line',
            scrollablePlotArea: {
              minWidth: 700,
              scrollPositionX: -1
            },
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
          },
          title: {
            text: '',
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: false,
          },
          tooltip: {
            shared: true,
          },
          xAxis: {
            gridLineWidth: 0,
            lineWidth: 0,
            tickWidth: 0,
            categories: ['13.07', '14.07', '15.07', '16.07', '17.07', '18.07', '19.07', '20.07', '21.07', '22.07', '23.07', '24.07', '25.07', '26.07', '27.07'],
            tickmarkPlacement: 'on',
            title: {
              text: ''
            }
          },
          yAxis: {
            gridLineWidth: 0,
            title: {
              text: ''
            }
          },
          colors: ['#00c2ff', '#ff5656', '#ffab48', '#6248ff', '#ff48ab', '#00e3ba'],
          plotOptions: {
            series:{
              dataLabels: {
                enabled: false
              }
            },
          },
          series: [{
            name: 'Bitcoin',
            marker:{
              enabled: false,
            },
            data: [7.0, 6.9, 9.5, 14.5, 18.4, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6, 10, 10, 10, 10, 11],
            type: "spline"
          }, {
            name: 'Ethereum',
            marker:{
              enabled: false,
            },
            data: [3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 6.6, 4.8, 3, 5, 6, 7, 8],
            type: "spline"
          }]
        }
      }
    },
    methods: {
		  reflow() {
        const {chart} = this.$refs.piChart;
        this.$nextTick(() => {
          chart.reflow();
        });
      }
    },
    beforeCreate() {
		  this.$root.$on('ex::sidebar::toggleMenu', this.reflow);
    }
	}
</script>

<style lang="scss">
  .pie-chart-container {
    max-width: 250px;
    margin: 0 auto;
    .highcharts-container {
      /*overflow: visible !important;*/
      width: 100% !important;
    }
    .e-pie-chart__tooltip {
      display: flex;
      padding: 2px 8px;
      position: relative;
      z-index: 50;

      .e-pie-chart__logo {
        margin-right: 10px;
      }

      .e-pie-chart__asset {
        font-family: Roboto, sans-serif;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #0e3d60;
      }

      .e-pie-chart__value {
        font-family: Roboto, sans-serif;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: normal;
        color: #7e96ad;
      }
    }

    .highcharts-title {
      font-family: Roboto, sans-serif !important;

      tspan {
        fill: #7e96ad !important;
        font-size: 12px;
        &:first-child {
          fill: #1354aa !important;
          font-weight: 500;
          font-size: 18px;
        }
      }
    }

    .highcharts-tooltip-box {
      fill: #fff;
      fill-opacity: 1;

      &:last-child {
        stroke-width: 0;
      }
    }

    .pie-chart-label span {
      font-family: Roboto, sans-serif !important;
      font-size: 12px !important;
      font-weight: normal !important;
      font-style: normal !important;
      font-stretch: normal !important;
      line-height: 1.25 !important;
      letter-spacing: normal !important;
      color: #ffffff !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cards/chart/chart.vue